<template lang="pug">
  .cart-shipping-message(v-if='exclusiveOffer.message')
    img.shipping-icon(:src='shippingIcon', :alt="isFreeShipping ? 'free-shipping-icon' : 'no-free-shipping-icon'")
    p(v-text='exclusiveOffer.message')
</template>

<script>
import freeShippingIcon from '../../../assets/images/icons/free-shipping-icon.svg'
import noFreeShippingIcon from '../../../assets/images/icons/no-free-shipping-icon.svg'

export default {
  name: 'CartShippingMessage',
  props: {
    exclusiveOffer: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isFreeShipping () {
      return this.exclusiveOffer['free-shipping']
    },
    shippingIcon () {
      return this.isFreeShipping ? freeShippingIcon : noFreeShippingIcon
    }
  }
}
</script>

<style lang="scss" scoped>
@import "app/assets/stylesheets/sass/_mixins.scss";
.cart-shipping-message {
  background-color: $light-red;
  padding: 8px 40px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 40px;

  .shipping-icon {
    max-width: 28px;
  }
}
</style>
